import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import {
    ITaxSettings, ITaxYear, ITaxExemption,
    IEmployeeTaxSummary, ITaxReportMonthly
} from '../interfaces/tax.interface';

const headers = () => AuthService.getAuthHeader();
const instId = () => AuthService.getSelectedInstitution()!;

export const TaxService = {
    getTaxSettings: async (institutionId?: string): Promise<ITaxSettings> => {
        const id = institutionId || instId();
        const res = await axios.get(ENDPOINTS.TAX_SETTINGS.BY_INSTITUTION(id), { headers: headers() });
        return res.data;
    },
    upsertTaxSettings: async (data: ITaxSettings): Promise<ITaxSettings> => {
        const res = await axios.post(ENDPOINTS.TAX_SETTINGS.UPSERT, data, { headers: headers() });
        return res.data;
    },

    getTaxYears: async (institutionId?: string): Promise<ITaxYear[]> => {
        const id = institutionId || instId();
        const res = await axios.get(ENDPOINTS.TAX_YEAR.BY_INSTITUTION(id), { headers: headers() });
        return res.data;
    },
    saveTaxYear: async (data: ITaxYear): Promise<ITaxYear> => {
        const res = await axios.post(ENDPOINTS.TAX_YEAR.SAVE, data, { headers: headers() });
        return res.data;
    },
    activateTaxYear: async (id: string, institutionId?: string): Promise<void> => {
        const instit = institutionId || instId();
        await axios.put(ENDPOINTS.TAX_YEAR.ACTIVATE(id), {}, {
            headers: headers(), params: { institutionId: instit }
        });
    },
    deleteTaxYear: async (id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.TAX_YEAR.DELETE(id), { headers: headers() });
    },

    getExemptions: async (institutionId?: string): Promise<ITaxExemption[]> => {
        const id = institutionId || instId();
        const res = await axios.get(ENDPOINTS.TAX_EXEMPTION.BY_INSTITUTION(id), { headers: headers() });
        return res.data;
    },
    saveExemptions: async (exemptions: ITaxExemption[], institutionId?: string): Promise<ITaxExemption[]> => {
        const id = institutionId || instId();
        const res = await axios.post(ENDPOINTS.TAX_EXEMPTION.SAVE_ALL(id), exemptions, { headers: headers() });
        return res.data;
    },

    getEmployeeTaxSummary: async (taxYearId: string, institutionId?: string): Promise<IEmployeeTaxSummary[]> => {
        const id = institutionId || instId();
        const res = await axios.get(ENDPOINTS.EMPLOYEE_TAX.SUMMARY(id, taxYearId), { headers: headers() });
        return res.data;
    },

    getMonthlySummary: async (taxYearId: string, year: number, month: number, institutionId?: string): Promise<ITaxReportMonthly> => {
        const id = institutionId || instId();
        const res = await axios.get(ENDPOINTS.TAX_REPORT.MONTHLY(id, taxYearId), {
            headers: headers(), params: { year, month }
        });
        return res.data;
    },
    downloadMonthlySummaryPdf: async (taxYearId: string, year: number, month: number, institutionId?: string): Promise<Blob> => {
        const id = institutionId || instId();
        const res = await axios.get(ENDPOINTS.TAX_REPORT.MONTHLY_PDF(id, taxYearId), {
            headers: headers(), params: { year, month }, responseType: 'blob'
        });
        return res.data;
    },
    downloadCertificatePdf: async (taxYearId: string, userId: string, institutionId?: string): Promise<Blob> => {
        const id = institutionId || instId();
        const res = await axios.get(ENDPOINTS.TAX_REPORT.CERTIFICATE_PDF(id, taxYearId, userId), {
            headers: headers(), responseType: 'blob'
        });
        return res.data;
    },
};
